import { Col, Form, InputNumber } from 'antd'
import React from 'react'

const CncMetaFields = ({ prefix }) => {
  return (
    <>
      <Col xs={24} md={4}>
        <Form.Item
          label="Cycle Time"
          name={[prefix, "cycle_time"]}
          rules={[
            {
              required: true,
              message: "Please input Cycle time...!",
            },
          ]}
        >
          <InputNumber
            defaultValue={0}
            placeholder="Cycle Time"
            addonAfter="sec"
            precision={0}
            style={{ width: "100%" }}
            size="small"
          />
        </Form.Item>
      </Col>
      <Col xs={24} md={5}>
        <Form.Item
          label="No of operations"
          name={[prefix, "machining_cycle"]}
          rules={[
            {
              required: true,
              message: "Please input No of operations...!",
            },
          ]}
        >
          <InputNumber
            defaultValue={0}
            addonAfter="sec"
            placeholder="No of operations"
            precision={0}
            style={{ width: "100%" }}
          />
        </Form.Item>
      </Col>
      <Col xs={24} md={5}>
        <Form.Item
          label="Raw Weight"
          name={[prefix, "raw_weight"]}
          rules={[
            {
              required: true,
              message: "Please input Raw weight...!",
            },
          ]}
        >
          <InputNumber
            defaultValue={0}
            addonAfter="gm"
            precision={2}
            placeholder="Raw Weight"
            style={{ width: "100%" }}
            size="small"
          />
        </Form.Item>
      </Col>
      <Col xs={24} md={5}>
        <Form.Item
          label="Finished Weight"
          name={[prefix, "finished_weight"]}
          rules={[
            {
              required: true,
              message: "Please input Finished weight...!",
            },
          ]}
        >
          <InputNumber
            defaultValue={0}
            addonAfter="gm"
            precision={2}
            placeholder="Finished Weight"
            style={{ width: "100%" }}
            size="small"
          />
        </Form.Item>
      </Col>
      <Col xs={24} md={5}>
        <Form.Item
          label="Units / box"
          name={[prefix, "units_per_box"]}
          rules={[
            {
              required: true,
              message: "Please Enter Units Per Box...!",
            },
            {
              type: "number",
              min: 1,
              message: "Units Per Box must be at least 1",
            },
          ]}
        >
          <InputNumber
            defaultValue={1}
            placeholder="Units Per Box"
            style={{ width: "100%" }}
            size="small"
          />
        </Form.Item>
      </Col>
    </>
  )
}

export default CncMetaFields